export default __webpack_public_path__ + "static/media/TOYOTA05.a0644408.png";